<template>
    <div>
        <h1>Grader</h1>
        <AddRankToMember />
        <h1>Test</h1>
        <b>Gamla grader</b>
        <ul>
            <li v-for="rank in oldRanks" :key="rank"><RankImage :rank="rank" /> - {{ rank }}</li>
        </ul>
        <b>Nya grader</b>
        <ul>
            <li v-for="rank in ranks" :key="rank"><RankImage :rank="rank" /> - {{ rank }}</li>
        </ul>
        <p>Done.</p>
    </div>
</template>

<script>
 import AddRankToMember from '@/components/AddRankToMember.vue'
 import RankImage from '@/components/RankImage.vue'
 import { ranks, oldRanks } from '@/utils/ranks.js'

 export default {
     components: { AddRankToMember, RankImage },
     data() {
         return {
             oldRanks: oldRanks,
             ranks: ranks
         }
     }
 }
</script>
